var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.902 3.285a2.262 2.262 0 0 1 2.196 0c3.351 1.883 13.449 7.55 16.804 9.434A2.125 2.125 0 0 1 43 14.566v18.868c0 .761-.418 1.464-1.098 1.847l-16.804 9.434a2.262 2.262 0 0 1-2.196 0L6.098 35.28A2.125 2.125 0 0 1 5 33.434V14.566c0-.761.418-1.464 1.098-1.847 3.351-1.883 13.453-7.551 16.804-9.434z",
    fill: "#283593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.305 34.402C5.039 34.047 5 33.711 5 33.254V14.496a2.11 2.11 0 0 1 1.094-1.836c3.343-1.87 13.406-7.508 16.75-9.379.676-.379 1.593-.37 2.27.008 3.343 1.871 13.37 7.457 16.714 9.328.27.153.477.336.66.578z",
    fill: "#5C6BC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10c7.727 0 14 6.273 14 14s-6.273 14-14 14-14-6.273-14-14 6.273-14 14-14zm0 7c3.863 0 7 3.137 7 7s-3.137 7-7 7-7-3.137-7-7 3.137-7 7-7z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.484 13.203c.516.485.508 1.211.508 1.785 0 3.797-.031 14.59.008 18.383.004.399-.129.816-.324 1.129L23.594 24z",
    fill: "#3949AB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.b39de3fe1b49bf5d14d530dbbd23c706.svg";
export { ForwardRef as ReactComponent };